import React, { useState, useCallback, useMemo, useEffect } from 'react';
import './NocAlertPanel.css';
import { Icon } from '../../globalUtils/globalIcons';
import { useAppDispatch } from '../../rmsReduxStore/rmsReduxHooks';
import { useAppSelector } from '../../globalUtils/globalExports'
import { chargerTypes, getFilterSelectedValue, getReferenceDataReducer } from '../../rmsReduxStore/reduxExports';
import { setFlagAlert } from '../../rmsReduxStore/reduxExports';
import { formatRelativeTimeForTableIST } from '../../globalUtils/globalHooks';
import { getCurrentFiltersValues, fetchNocDashboardAlertsList } from '../../rmsReduxStore/reduxExports';
import { toast } from 'react-toastify';
import { setChargerIdsForRedirection } from '../../rmsReduxStore/reduxExports';
import { HorizontalNavbar, CustomTooltipWithLabel } from '../../globalUtils/globalExports'
import CustomPulseLoader from '../softwareReleaseManagement/dashboard/CustomPulseLoader';
import CustomFilterLayout, { CustomFilterProp } from '../newDashboard/CustomFilterLayout';


interface IAlertsList {
  id: string,
  alarmName: string,
  setTime: string,
  severity: string,
  status: string,
  chargerName: string,
  ocppId: string,
  chargingStationName: string,
  customerName: string,
  productType: string,
  flaggedAt?: string
  connectorNo?: number
  connectorType?: string
  chargerId?:string


}
interface FilterItem {
  key: string;
  values: string[];
}
interface FilterOption {
  id: string;
  value: string;
  label: string;
  name: string;
}
interface Props {
  open: boolean;
  onClose: () => void;
  alertsLists?: IAlertsList[] | null;
  ToogleAlertFilter: () => void;
  isFlagged?: boolean;
  alertCount?:number;

}
export const alarmCardMapper = {
  Critical: {
    title: 'Critical',
    color: 'var(--critical-alarm-color)',
    alarmSummaryIcon: 'rms__icon critical__alarm__icon'
  },
  Major: {
    title: 'Major',
    color: 'var(--major-alarm-color)',
    alarmSummaryIcon: 'rms__icon major__alarm__icon'
  },
  Minor: {
    title: 'Minor',
    color: 'var(--minor-alarm-color)',
    alarmSummaryIcon: 'rms__icon minor__alarm__icon'
  }
}
export default function NocAlertsPanel({ open, onClose, alertsLists,alertCount }: Props) {
  const dispatch = useAppDispatch();
  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLElement | null>(null);
  const [localAlerts, setLocalAlerts] = useState<IAlertsList[]>([]);
  const [selectedNav, setSelectedNav] = useState<'latestalerts' | 'flaggedalerts'>('latestalerts');
  const [isLoading, setIsLoading] = useState(false);
  const [activeFilters, setActiveFilters] = useState<FilterItem[]>([]);
  const [selectedFiltersData, setSelectedFiltersData] = useState<{ severity: FilterOption[] | null; alarmType: FilterOption[] | null; }>({ severity: null, alarmType: null, });
  const { alarmTypeReferenceData, alarmSeverityReferenceData } = useAppSelector(getReferenceDataReducer);

const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);

const toggleDiagnostics = (id: string) => {
  setOpenDropdownId(prev => (prev === id ? null : id));
};

const closeDropdown = () => setOpenDropdownId(null);

useEffect(() => {
  const handler = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.diagnostics-wrapper')) {
      closeDropdown();
    }
  };

  document.addEventListener('click', handler);
  return () => document.removeEventListener('click', handler);
}, []);
const handleChargerNavigation = (chargerId: string, chargerVisibleId: string,selectedNav: string) => {
    dispatch(setChargerIdsForRedirection([chargerId]))
    const chargerAction = {
          type: chargerTypes.SET_SELECTED_NAV,
          selectedNav: selectedNav
      }
    dispatch(chargerAction)
    window.open(`/charger?chargerId=${chargerVisibleId}&redirectedFrom=nocDashboard`, '_blank');
  }
  const markFlagAlert = async (alertId?: string, actionType?: string) => {
    const res = await dispatch(setFlagAlert({ alertId, actionType }));

    if (res?.status === 200) {
      toast.success(res?.data?.message || 'Alert flagged successfully');

      setLocalAlerts(prev =>
        prev.map(alert =>
          alert.id === alertId
            ? {
              ...alert,
              flaggedAt: actionType === 'unflagAlert' ? undefined : new Date().toISOString()
            }
            : alert
        )
      );
    }
    else {
      toast.error(res?.data?.message || 'Something went wrong. Please try again.');
    }
  };



  const handleNavBtnClick = useCallback((val) => {
    setSelectedNav(val);
  }, []);  
useEffect(() => {
  if (!open) return;
  setIsLoading(true);

  dispatch(fetchNocDashboardAlertsList({
    filters: activeFilters,
    searchTerm: '',
    fetchType: selectedNav === 'flaggedalerts' ? 'flaggedAlerts' : ''
  }));
}, [activeFilters, selectedNav, dispatch]);


  useEffect(() => {
    setIsLoading(false);
    if (alertsLists) {
      const sorted = [...alertsLists].sort((a, b) => {
        const aFlag = a.flaggedAt ? new Date(a.flaggedAt).getTime() : 0;
        const bFlag = b.flaggedAt ? new Date(b.flaggedAt).getTime() : 0;

        if (aFlag && bFlag) return bFlag - aFlag;
        if (aFlag) return -1;
        if (bFlag) return 1;
        return 0;
      });

      setLocalAlerts(sorted);
    }
  }, [alertsLists]);

useEffect(() => {
  if (open) {
    setSelectedNav('latestalerts');
    const initialFilters = getCurrentFiltersValues('nocDashboard', false);
    setActiveFilters(initialFilters);
    setSelectedFiltersData({
      severity: null,
      alarmType: null,
    });
  }
}, [open]);
  // useEffect(() => {
  //   if (open) {
  //     // When opening panel → always load latest alerts
  //     setIsLoading(true);
  //     const filters = getCurrentFiltersValues('nocDashboard', false);

  //     dispatch(
  //       fetchNocDashboardAlertsList({
  //         filters: filters,
  //         searchTerm: '',
  //         fetchType: '' // latest alerts
  //       })
  //     );
  //   }
  // }, [open]);


  const headerdata = [{
    id: 'latestalerts',
    text: 'Latest Alerts',
    isAccessible: true,
  },
  {
    id: 'flaggedalerts',
    text: 'Flagged Alerts',
    isAccessible: true,
  },
  ]
  const navBarconfigurations = useMemo(() => {
    return {
      selectedNav: selectedNav,
      navList: headerdata?.filter((nav) => nav?.isAccessible),
      onNavClick: handleNavBtnClick
    }
  }, [selectedNav])


  const handleFilterDataChange = async (
    val: FilterOption | FilterOption[],
    type: 'severity' | 'alarmType'
  ) => {
    setIsLoading(true);
    const filters = getCurrentFiltersValues('nocDashboard', false);
    const updatedFilters = [...filters];
    if (type === 'severity') {
      const selectedVal = val as FilterOption;
      const index = updatedFilters.findIndex(f => f.key === 'severity');
      if (index > -1) {
        updatedFilters[index].values = [selectedVal.value];
      } else {
        updatedFilters.push({ key: 'severity', values: [selectedVal.value] });
      }
      setSelectedFiltersData(prev => ({ ...prev, severity: [selectedVal] }));

    } else if (type === 'alarmType') {
      const selectedVals = val as FilterOption[];
      const values = selectedVals.map(v => v.value);

      const index = updatedFilters.findIndex(f => f.key === 'alarmType');
      if (index > -1) {
        updatedFilters[index].values = values;
      } else {
        updatedFilters.push({ key: 'alarmType', values });
      }
      setSelectedFiltersData(prev => ({ ...prev, alarmType: selectedVals }));
    }
    if (!updatedFilters.some(f => f.key === 'severity') && selectedFiltersData.severity?.length) {
      updatedFilters.push({ key: 'severity', values: selectedFiltersData.severity.map(v => v.value) });
    }
    if (!updatedFilters.some(f => f.key === 'alarmType') && selectedFiltersData.alarmType?.length) {
      updatedFilters.push({ key: 'alarmType', values: selectedFiltersData.alarmType.map(v => v.value) });
    }
    setActiveFilters(updatedFilters);
  };

  const FilterProps: CustomFilterProp[] = useMemo(() => {
    return [
      {
        filterLabel: 'Severity',
        filterId: 'category',
        filterType: 'dropdown',
        filterDropdownProps: {
          selectValue: selectedFiltersData.severity,
          selectOptions: alarmSeverityReferenceData?.filter((item) => item.id !== 'No Alarm') ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'severity')
          },
          selectDropDownId: 'alarm-severity-filter-dropdown',
          isMultiSelect: false,
          renderToBody:true
        }
      }, {
        filterLabel: 'Alarms',
        filterType: 'dropdown',
        filterId: 'alarmType',
        filterDropdownProps: {
          selectValue: selectedFiltersData.alarmType,
          selectOptions: alarmTypeReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'alarmType')
          },
          selectDropDownId: 'alarm-alarmType-filter-dropdown',
          isMultiSelect: true,
          renderToBody:true
        }
      },
    ]
  }, [alarmTypeReferenceData, alarmSeverityReferenceData, handleFilterDataChange, getFilterSelectedValue])

    const handleChargerClicked = (chargerSerialId, chargerId) => {
        dispatch(setChargerIdsForRedirection([chargerId]))
        window.open(`/charger?chargerId=${chargerSerialId}&redirectedFrom=nocDashboard`, '_blank');
    }

  if (!open) return null;
  return (
    <div>
      <div className='noc-dashboard-alert-overlay'>
        <div className='noc-dashboard-alert-box'>
          {/* Header */}
          <div className='noc-dashboard-alert-header'>
            <div className='noc-dashboard-alert-title'>
              {/* {isFlagged ? 'Flagged Alerts' : 'Latest Alerts'} */}
              <HorizontalNavbar
                selectedNav={navBarconfigurations?.selectedNav}
                navList={navBarconfigurations?.navList}
                onNavClick={(event, val) => { event?.stopPropagation(); navBarconfigurations?.onNavClick?.(val) }}
              />
            </div>
            <div className='noc-dashboard-alert-header-actions'>
              <button
                className="noc-dashboard-alert-chip-filter"
                onClick={(e) => setFilterAnchorEl(e.currentTarget)}
              >
                Filters
              </button>

              {filterAnchorEl && (
                <div className='noc-dashboard-alert-filter'>
                  <CustomFilterLayout
                    filters={FilterProps}
                    requiredReferenceDataCallbacks={['alarmType', 'severity']}
                    filterAnchorEl={filterAnchorEl}
                    setFilterAnchorEl={setFilterAnchorEl}
                    excludeGlobalFilters={true}
                  />
                </div>
              )}

              <button className='noc-dashboard-alert-close' onClick={onClose}>✕</button>
            </div>
          </div>
          <div className='noc-dashboard-alert-list'>
            {isLoading && (
              <div className='noc-dashboard-alert-loader'>
                <CustomPulseLoader showLoader={isLoading} size={20} />
              </div>
            )}
            {!isLoading && (!alertsLists || alertsLists.length === 0) && (
              <div className="noc-dashboard-alert-empty">
                <Icon iconClassName='rms__icon no__alarms__icon' />
                No alerts available
              </div>
            )}

            {!isLoading && localAlerts &&
              localAlerts?.length > 0 &&
              localAlerts?.map((alert, index) => {
                const isTopAlert = index < (alertCount ?? 0);
                return (
                    <div
                    key={index}
                    className={`noc-dashboard-alert-card ${isTopAlert ? 'noc-dashboard-alert-card--highlight' : ''}`}>
                    <div className='noc-dashboard-alert-info-block'>
                      <div className='noc-dashboard-alert-device-row'>
                        <div className='noc-dashboard-icon-row'>
                          <Icon iconClassName='noc-dashboard-right-panel-charger-icon' />
                          <span className='noc-dashboard-alert-device-id' onClick={() => { handleChargerClicked(alert?.chargerName, alert?.chargerId) }}>{alert?.chargerName}</span>
                          <span className='noc-dashboard-alert-ocpp-id-label'>|

                          </span>
                          <div className='noc-dashboard-alert-ocpp-id-value'>
                            {alert?.ocppId}
                          </div>
                          <span className='noc-dashboard-alert-ocpp-id-label'>|

                          </span>    
                          <Icon iconClassName='rms__icon noc-dashboard-right-panel-user-icon'/>
                          <CustomTooltipWithLabel label={alert?.customerName ?? ''} labelId={`noc-alert-customer-${alert?.id}`} containerClassName='noc-dashboard-alert-ocpp-id-value noc-dashboard-alert-customer-name' tooltipZIndex={10000} />
                             <span className='noc-dashboard-alert-ocpp-id-label'>|

                          </span>    
                          <span className='noc-dashboard-alert-chip-tag'>{alert?.productType}</span>

                        </div>

                        <div className='noc-dashboard-alert-actions'>
                      <div className="diagnostics-wrapper">
                        <button
                      className='noc-dashboard-alert-dropdown'
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDiagnostics(alert.id);
                      }}
                    >
                    <span>Diagnostics</span> 
                    <span className='noc-dashboard-dropdown-icon'>
                      <Icon iconClassName='rms__icon noc-dashboard-hide-metric-card-bar-icon'/>
                      </span>
                    </button>

              {openDropdownId === alert.id && (
                <div className='diagnostics-menu'>
                  <div className='diagnostics-item' onClick={() => { handleChargerNavigation(alert?.chargerId ?? '', alert?.chargerName,'settings') }}>Set Parameters</div>
                  <div className='diagnostics-item' onClick={() => { handleChargerNavigation(alert?.chargerId ?? '', alert?.chargerName,'remote_commands') }}>Remote Command</div>
                </div>
              )}
</div>


                          {alert?.flaggedAt ? (
                            <div className='noc-dashboard-flag-btn' onClick={() => markFlagAlert(alert?.id, 'unflagAlert')}>
                              <Icon iconClassName='noc-dashboard-alert-panel-flag-icon' />
                            </div>
                          ) : (
                            <div className='noc-dashboard-flag-btn' onClick={() => markFlagAlert(alert?.id)}>
                              {/* <FlagOutline size={25} color="#6B7280" ariaLabel="Flag outline - not flagged" /> */}
                              <Icon iconClassName='noc-dashboard-alert-panel-unflag-icon' />
                            </div>
                          )}
                        </div>
                      </div>

                      {/* <div className='noc-dashboard-alert-device-row'> */}
                      {/* <div className='noc-dashboard-alert-org'>{alert?.chargingStationName}</div> */}
                      {/* <div className='noc-dashboard-alert-detail-row'>
                <UserIcon />
                <div>{alert?.customerName}</div>
              </div> */}
                      {/* </div> */}

                      <div className='noc-dashboard-alert-desc-row'>
                        <div className='noc-dashboard-alert-desc-sub-row'>
                          <div className={`rms__icon ${alert?.severity.toLowerCase()}__alarm__icon`}></div>
                      <span className='noc-dashboard-alert-desc-row-text'>
  {alert?.alarmName}

  {alert?.connectorNo && alert?.connectorType && (
    <> at {alert.connectorNo}-{alert.connectorType}</>
  )}
</span>

                        </div>

                        <div className='noc-dashboard-alert-timestamp'>
                          Set Time : {formatRelativeTimeForTableIST(alert?.setTime)}
                        </div>
                      </div>

                    </div>



                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
}
